import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, message, Spin } from "antd";
import { FC, useState } from "react";
import { selectedIconSVG } from "../../../../assets/SVGs/SVGs";
import { useIntl } from "react-intl";
import queryClient from "../../../../services/react-query/queryClient";

interface ChangePaymentMethodProps {
  getPaymentMethods: () => Promise<any>;
  paymentMethod: { id: number; name: string } | null;
  setPaymentMethod: React.Dispatch<
    React.SetStateAction<{
      id: number;
      name: string;
    } | null>
  >;
  onCancel: () => void;
  isAdmin?: boolean;
  updatePaymentMethod?: (paymentMethodId: number) => Promise<any>;
  queryKey?: string[];
}

const ChangePaymentMethod: FC<ChangePaymentMethodProps> = ({
  getPaymentMethods,
  paymentMethod,
  setPaymentMethod,
  onCancel,
  isAdmin,
  updatePaymentMethod,
  queryKey,
}) => {
  const intl = useIntl();
  const [selectedPaymentMethod, setSelectedPaymentMethodId] = useState<
    number | null
  >(paymentMethod?.id || null);
  const { data: paymentMethods, isLoading } = useQuery(
    ["paymentMethods"],
    () => {
      if (isAdmin) {
        return getPaymentMethods(); //! change it to the admin api when it ready
      } else {
        return getPaymentMethods();
      }
    },
    {
      select: (res) => res?.data,
    }
  );
  const { mutate, isLoading: isUpdating } = useMutation(
    () => {
      if (selectedPaymentMethod) {
        if (updatePaymentMethod) {
          return updatePaymentMethod(selectedPaymentMethod);
        }
      }
      return Promise.resolve();
    },
    {
      onSuccess: (res: any) => {
        if (res?.code !== "ERR_BAD_REQUEST") {
          message.success(
            res?.message ||
              intl.formatMessage({
                id: "updatedSuccessfully",
                defaultMessage: "تم التعديل بنجاح",
              })
          );
          queryClient.invalidateQueries(queryKey);
          if (onCancel) {
            onCancel();
          }
        }
      },
      onError: (err: any) => {
        message.error(
          err?.response?.data?.message ||
            intl.formatMessage({
              id: "somethingWentWrong",
              defaultMessage: "حدث خطأ ما",
            })
        );
      },
    }
  );
  const handleSubmit = () => {
    const method = paymentMethods?.find(
      (method: { id: number; name: string }) =>
        method?.id === selectedPaymentMethod
    );
    setPaymentMethod(method);
    if (updatePaymentMethod) {
      mutate();
    }
    if (!updatePaymentMethod && onCancel) {
      onCancel();
    }
  };
  return (
    <div className="space-y-3 p-2">
      <div className="my-3 p-2 w-full">
        <p className=" text-[#75757E] my-2">
          {intl.formatMessage({
            id: "payWith",
            defaultMessage: "الدفع من خلال",
          })}
        </p>
        <Spin spinning={isLoading} className="">
          <div className="grid grid-cols-2 gap-2 my-2 ">
            {paymentMethods?.map((method: { id: number; name: string }) => {
              return (
                <Button
                  key={method?.id}
                  type="default"
                  htmlType="button"
                  className={
                    "  col-span-1  w-full flex justify-center items-center gap-1 " +
                    (selectedPaymentMethod === method?.id
                      ? "text-[#479821] border-[#479821]"
                      : "")
                  }
                  onClick={() => setSelectedPaymentMethodId(method?.id)}
                >
                  {selectedPaymentMethod === method?.id ? (
                    <span className="mt-1">{selectedIconSVG}</span>
                  ) : null}
                  <span className="">{method.name}</span>
                </Button>
              );
            })}
          </div>
          <div className="flex gap-4 mt-8 ">
            <Button
              type="primary"
              htmlType="button"
              className="w-full"
              onClick={handleSubmit}
              loading={isUpdating}
              disabled={
                !selectedPaymentMethod ||
                paymentMethod?.id === selectedPaymentMethod
              }
            >
              {intl.formatMessage({
                id: updatePaymentMethod ? "saveChanges" : "save",
                defaultMessage: "حفظ",
              })}
            </Button>

            <Button
              type="default"
              htmlType="button"
              className="w-full"
              onClick={onCancel}
            >
              {intl.formatMessage({ id: "cancel", defaultMessage: "الغاء" })}
            </Button>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default ChangePaymentMethod;
